const _temp0 = require("../images/developers/eduard.jpg");
const _temp1 = require("../images/developers/igor.jpg");
const _temp2 = require("../images/developers/inna-shkilna.jpg");
const _temp3 = require("../images/developers/inna-zadorozhnia.jpg");
const _temp4 = require("../images/developers/natalia.jpg");
const _temp5 = require("../images/developers/oleksandr.jpg");
const _temp6 = require("../images/developers/tetiana.jpg");
const _temp7 = require("../images/developers/viktoria.jpg");
const _temp8 = require("../images/developers/vladyslav.jpg");
const _temp9 = require("../images/developers/yan.jpg");
module.exports = {
  "eduard": _temp0,
  "igor": _temp1,
  "inna-shkilna": _temp2,
  "inna-zadorozhnia": _temp3,
  "natalia": _temp4,
  "oleksandr": _temp5,
  "tetiana": _temp6,
  "viktoria": _temp7,
  "vladyslav": _temp8,
  "yan": _temp9
}